export const ADD_COURSES_DIALOG = 'ADD_COURSES_DIALOG';
export const COURSE_RESET_DATA = 'COURSE_RESET_DATA';
export const COURSE_ITEM_CHANGE = 'COURSE_ITEM_CHANGE';
export const SET_ADD_COURSE_MODAL_SCROLL = 'SET_ADD_COURSE_MODAL_SCROLL';
export const ADD_COURSE_MODAL_SCROLL_RESTORED = 'ADD_COURSE_MODAL_SCROLL_RESTORED';
